<template>
  <div class="superuser-info-table">
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        {{ tStatic("superUserProductInfoStockAvailable") }}
        <!-- Aktuellt lagersaldo: -->
      </div>
      <div class="superuser-info-table__column">
        {{ stockAvailable }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- Leverantorens lager: -->
        {{ tStatic("superUserProductInfoVendorStock") }}
      </div>
      <div class="superuser-info-table__column">
        {{ vendorStockBalance }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- Ledtid för huvudleverantör: -->
        {{ tStatic("superUserProductInfoDeliverTime") }}
      </div>
      <div class="superuser-info-table__column">
        {{ deliveryTime }}
      </div>
    </div>

    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- Beräknad åter i lager: -->
        {{ tStatic("superUserProductInfoDeliverDate") }}
      </div>
      <div class="superuser-info-table__column">
        {{ deliveryDate }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- Inköpspris -->
        {{ tStatic("superUserPurchasePrice") }}
      </div>
      <div class="superuser-info-table__column">
        {{ purchasePrice }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- Rabattgrupp -->
        {{ tStatic("superUserItemDiscountGroup") }}
      </div>
      <div class="superuser-info-table__column">
        {{ itemDiscountGroup }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- Monteringsdetaljer -->
        {{ tStatic("superUserItemAssemblyDetails") }}
      </div>
      <div class="superuser-info-table__column">
        {{ itemAssemblyDetails }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- Länk till artikeln i BC -->
        {{ tStatic("superUserBCArticleLinkLabel") }}
      </div>
      <div class="superuser-info-table__column">
        <a :href="bcArticleLink" target="_blank" class="superuser-info-link"><span>{{ bcArticleLink }}</span></a>
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- ProdBase-artikel: -->
        {{ tStatic("superUserProductInfoIsProdBaseItem") }}
      </div>
      <div class="superuser-info-table__column">
        {{ yesNo(isProdBaseItem) }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- ProdBase-artikel i ERP: -->
        {{ tStatic("superUserProductInfoIsProdBaseItemViaBC") }}
      </div>
      <div class="superuser-info-table__column">
        {{ yesNo(isProdBaseItemViaBC) }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- ProdBase-status: -->
        {{ tStatic("superUserProductInfoProdBaseStatus") }}
      </div>
      <div class="superuser-info-table__column">
        {{ prodBaseStatus }}
      </div>
    </div>
    <div class="superuser-info-table__row">
      <div class="superuser-info-table__head">
        <!-- ProdBase-leverantör: -->
        {{ tStatic("superUserProductInfoProdBaseVendorCode") }}
      </div>
      <div class="superuser-info-table__column">
        {{ prodBaseVendorCode }}
      </div>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    productNumber: {
      type: String,
      required: true
    },
    itemNumber: {
      type: String,
      required: true
    }
  },
  data: () => ({
    stockAvailable: null,
    vendorStockBalance: null,
    isProdBaseItem: null,
    isProdBaseItemViaBC: null,
    prodBaseStatus: null,
    prodBaseVendorCode: null,
    deliveryTime: null,
    deliveryDate: null,
    purchasePrice: null,
    itemDiscountGroup: null,
    itemAssemblyDetails: null,
    bcArticleLink: null
  }),
  computed: {},
  mounted() {
    httpService
      .get('superuser/product/', {
        productNumber: this.productNumber,
        itemNumber: this.itemNumber
      })
      .then(response => {
        this.stockAvailable = response.data.stockAvailable
        this.vendorStockBalance = response.data.vendorStockBalance
        this.isProdBaseItem = response.data.isProdBaseItem
        this.isProdBaseItemViaBC = response.data.isProdBaseItemViaBC
        this.prodBaseStatus = response.data.prodBaseStatus
        this.prodBaseVendorCode = response.data.prodBaseVendorCode
        this.deliveryTime = response.data.deliveryTime
        this.deliveryDate = response.data.deliveryDate
        this.purchasePrice = response.data.purchasePrice
        this.itemDiscountGroup = response.data.itemDiscountGroup
        this.itemAssemblyDetails = response.data.itemAssemblyDetails

        this.bcArticleLink = this.tStatic('superUserBCArticleLinkTemplate').replace('{itemNumber}', this.itemNumber)
      })
  },
  methods: {
    // A flag the article does not carry at all is left blank rather than shown as a No, so
    // "we have no answer" and "the answer is no" stay apart on a panel read for diagnosis.
    yesNo(value) {
      if (value === null || value === undefined) {
        return ''
      }

      return value ? this.tStatic('genericYes') : this.tStatic('genericNo')
    }
  }
}
</script>

<style lang="scss">
.superuser-info-table {
  display: table;
}

.superuser-info-table__row {
  display: table-row;
}

.superuser-info-table__head {
  display: table-cell;
  padding-right: measure(quarter);
  padding-bottom: measure(quarter);
}

.superuser-info-table__column {
  display: table-cell;
  font-weight: bold;
}

.superuser-info-link {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  color: #006DB6;
  display: flex;
  align-items: center;
  min-height: 2.5rem;
  max-width: 43rem;
  text-decoration: none;
}

.superuser-info-link > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0; /* essential for flex truncation */
  display: block;
}
</style>
